import { render, staticRenderFns } from "./PhonesBlacklistPage.vue?vue&type=template&id=009a0729&scoped=true"
import script from "./PhonesBlacklistPage.vue?vue&type=script&lang=js"
export * from "./PhonesBlacklistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a0729",
  null
  
)

export default component.exports